"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var iconPreparer = function (icon, drupalIcons) {
    return drupalIcons && icon !== '' ? drupalIcons[icon] : undefined;
};
exports.default = iconPreparer;
//# sourceMappingURL=iconPreparer.js.map